/**
 * @file Provides PosturinnClientCoreModule.
 */
import { ModuleWithProviders, NgModule, Provider } from '../common-react/injection';

import { AddressService, IAddressService } from './services/address.service';
import { CurrentAccountVerificationService, ICurrentAccountVerificationService } from './services/current-account-verification.service';
import { CustomsService, ICustomsService } from './services/customs.service';
import { DeliveryServicesService, IDeliveryServicesService } from './services/delivery-services.service';
import { FamilyMembersService, IFamilyMembersService } from './services/family-members.service';
import { ILocationService, LocationService } from './services/location.service';
import { IRefundService, RefundService } from './services/refund.service';
import { IRegisterShipmentService, RegisterShipmentService } from './services/register-shipment.service';
import { ISearchService, SearchService } from './services/search.service';
import { IShipmentService, ShipmentService } from './services/shipment.service';
import { IUserProfileService, UserProfileService } from './services/user-profile.service';


@NgModule({
  imports: [],
})
export class PosturinnClientCoreModule {
  public static readonly PROVIDERS: Provider[] = [
    {
      provide: IAddressService,
      useClass: AddressService,
    },
    {
      provide: ICurrentAccountVerificationService,
      useClass: CurrentAccountVerificationService,
    },
    {
      provide: ICustomsService,
      useClass: CustomsService,
    },
    {
      provide: IDeliveryServicesService,
      useClass: DeliveryServicesService,
    },
    {
      provide: IFamilyMembersService,
      useClass: FamilyMembersService,
    },
    {
      provide: ILocationService,
      useClass: LocationService,
    },
    {
      provide: IRegisterShipmentService,
      useClass: RegisterShipmentService,
    },
    {
      provide: ISearchService,
      useClass: SearchService,
    },
    {
      provide: IShipmentService,
      useClass: ShipmentService,
    },
    {
      provide: IUserProfileService,
      useClass: UserProfileService,
    },
    {
      provide: IRefundService,
      useClass: RefundService,
    }
  ];

  public static forRoot(): ModuleWithProviders<PosturinnClientCoreModule> {
    return {
      ngModule: PosturinnClientCoreModule,
      providers: PosturinnClientCoreModule.PROVIDERS,
    };
  }
}
